.root {
  hyphens: auto;
}